import { createSelector } from 'reselect'

import { RootState } from './store'

const getApiState = (state: RootState) => state?.api

export const getApiQueries = createSelector(getApiState, (apiState) => apiState?.queries)
